/**
 * flash messaging js
 * @param domID
 * @param messages
 * @param delay
 */
window.flashMessage = function (domID,messages , delay) {
    if (delay === undefined ){
        delay = 20 * 1000;
    }
    if ( messages === undefined ){
        messages = [];
    }
    this.delay = delay;
    this.messages = messages;
    this.dom = domID;
};

flashMessage.prototype = {
    constructor : flashMessage,
    showMessages : function () {
        var messages = this.messages;
        var messageApp = this;
        var k = 0 ;
        $.each(messages,function(type , message){
            messageApp.show(message , type , messages.length);

            k = k + 1;
        });
    },
    show : function (message , type , index , count) {
        index = parseInt(index) + 1;
        var toastrOption = {
            "closeButton": true,
            "debug": false,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "3000",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
        type = ( type === "danger" ) ? "error" : type;
        switch (type) {
            case "success":
            case "info":
            {
                toastrOption['timeOut'] = "10000";
                break;
            }
            case "error":
            case "warning":
            {
                toastrOption['timeOut'] = "600000";
                break;
            }
        }
        $.each($(".toast-message"),function(){
            if ($(this).html() === message){
                $(this).parent('.toast').remove();
            }
        });
        if ( typeof type !== null ) {
            try {
                toastr[type](message, '', toastrOption);
            } catch ( error ) {
                return false;
            }
        }
    },
    hide : function (id){
        var $msg = $("#" + id );
        $msg.fadeOut(700);
        setTimeout( function(){ $msg.remove();},700);
    },
    add : function(message,type){
        this.messages.push({type : message });
        //has bug :(
    }
};

/**
 * Quick show message
 */
window.flashMessageLazy = function (status , msg , removeAll){
    if ( status == "success" ){
        var flash_messages = {success : msg};
    }else if (status == "danger" ){
        var flash_messages = {danger : msg};
    } else{
        var flash_messages = {info : msg};
    }
    var flash_msgs = new flashMessage("flashMessage",flash_messages,12000);

    if (removeAll === true){
        $('#flashMessage .alert').hide();
    }
    flash_msgs.showMessages();
};